import { HelmetDexteel } from "@dexteel/mesf-core";
import { ProductTypesManager } from "./components/ProductTypesManager";

export const ProductTypesPage = () => {
	return (
		<>
			<HelmetDexteel title="Product Types" />
			<ProductTypesManager />
		</>
	);
};
